<template>
  <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
    <g>
      <circle cx="16" cy="16" r="16" fill="#e75300" />
      <path
        d="M15.9 11.4l1.1-1.1c1.9-1.9 4.9-1.9 6.8 0 1.9 1.9 1.9 4.9 0 6.8L15.9 25 8 17.1c-1.9-1.9-1.9-4.9 0-6.8 1.9-1.9 4.9-1.9 6.8 0l1.1 1.1z"
        fill="#fff"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconHeartActive"
};
</script>
